import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import {GetWidgetConfig} from './Vendors/SizerAppAPI';
import getTheme from "./_common/GetTheme";
// import translationEN from './locales/en/strings.json';
// import translationHE from './locales/he/strings.json';

import defaultEn from './_themes/default/text/en-us.json'
import defaultEs from './_themes/default/text/es.json'
import defaultHe from './_themes/default/text/he-IL.json'
import triumphEn from './_themes/triumph/text/en-us.json'
import triumphEs from './_themes/triumph/text/es-ES.json'
import triumphDe from "./_themes/triumph/text/de-DE.json"
import triumphIt from "./_themes/triumph/text/it-IT.json"
import triumphFr from "./_themes/triumph/text/fr-FR.json"
import triumphPl from "./_themes/triumph/text/pl-PL.json"
import triumphHu from "./_themes/triumph/text/hu-HU.json"
import triumphCs from "./_themes/triumph/text/cs-CS.json"
import triumphHe from "./_themes/triumph/text/he.json"
import geltexDe from "./_themes/geltex/text/de-DE.json"
import wacoalEn from './_themes/wacoal/text/en-us.json'
import zylerEn from './_themes/zyler/text/en-us.json'
import barrierEn from './_themes/barrier/text/en-us.json'


function setI18n(){
  const lang_att  = GetWidgetConfig().lang;
  const urlQuery = new URLSearchParams(document.location.search)
  const lang_quary =urlQuery.get('lang');
  let lang = "en";
  if(lang_att) lang = lang_att;
  if(lang_quary) lang = lang_quary;
  let resources = setResources();
  i18n
  .use(initReactI18next) 
  // detect user language 
  .use(LanguageDetector)
  .init({
    resources,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  if(lang) {
    i18n.changeLanguage(lang);
  }
  let phoneLang = i18n.language.substring(0, 2);
  if (!resources[phoneLang]){
    i18n.changeLanguage('en');
  }
 // var a = i18n.language;
//  alert(a);  
//i18n.changeLanguage('en-us');
//i18n.changeLanguage('es');
let code = i18n.language.substring(0, 2);
window.sizer_language_code = code;
window.sizerLangJson = resources[code];
}

function setResources() {
    switch (getTheme()) {
      case 'triumph':
        return (
          {
            en: {
              translation: triumphEn
            },
            he: {
              translation: triumphHe
            },
            es: {
                translation: triumphEs 
              },
            it: {
              translation: triumphIt 
            },
            de: {
              translation: triumphDe
            },
            fr: {
              translation: triumphFr
            },
            pl: {
              translation: triumphPl
            },
            hu: {
              translation: triumphHu
            },
            cs: {
              translation: triumphCs
            }
          }
        )
      
        case 'wacoal':
          return (
            {
              en: {
                translation: wacoalEn
              }
            }
          )
        case 'geltex':
          return (
            {
              de: {
                translation: geltexDe
              }
            }
          )

        case 'zyler':
          return (
              {
                en: {
                  translation: zylerEn
                }
              }
            )

          case 'barrier':
            return (
              {
                en: {
                  translation: barrierEn
                }
              }
            )
              

      default:
        return (
          {
            en: {
              translation: defaultEn
            },
            es: {
              translation: defaultEs 
            },
            he: {
              translation: defaultHe 
            },
      }
        )
    }
}  
  export default setI18n;
  